module.exports = __webpack_public_path__ + "media/assets/images/SVG/x-0e565b78a5b4bee9a991ccd15f35ef71.svg";